import {
  GetProjectsQuery,
  GetProjectsQueryVariables,
  QueryHookOptions,
  useGetProjectsQuery,
} from '@sketch/gql-types'
import { useFlag } from '../flags'

/**
 * Hook to know if the workspace has a drafts project or not.
 * (Guest don't have any Drafts folder in the workspace by default)
 */
export function useGetHasDraftsProject(
  workspaceId: string,
  options: OmitSafe<
    QueryHookOptions<GetProjectsQuery, GetProjectsQueryVariables>,
    'variables'
  > = {}
) {
  const workspaceResult = useGetProjectsQuery({
    ...options,
    variables: { workspaceId, topLevel: !useFlag('nested-projects') },
  })
  const { data: workspaceData } = workspaceResult
  const hasDraftsProject = Boolean(
    workspaceData?.workspace.draftsProject?.entries[0]
  )

  return hasDraftsProject
}
